<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'sample-sampleInformation',
  components: {
    PageTable,
  },
}
</script>
